// FM = Functional Module
import moment from "moment";

export const getTimestamp = ({ year, month }) => {
  if (year && month) {
    console.log(year, month);
    return moment({ year, month }).valueOf();
  }
  return null;
};

export const getMonthFirstDate = ({ year, month }, unix = false) => {
  if (!year || !month) {
    return null;
  }
  const date = moment({
    year: year,
    month: month - 1,
  });

  if (unix) {
    return date.unix();
  } else {
    return date.format("YYYY-MM-DD");
  }
};

export const getMonthLastDate = ({ year, month }, unix = false) => {
  if (!year || !month) {
    return null;
  }
  const date = moment({
    year: year,
    month: month - 1,
  })
    .add(1, "month")
    .subtract(1, "second");

  if (unix) {
    return date.unix();
  } else {
    return date.format("YYYY-MM-DD");
  }
};

export const itaijiFM = {
  // 異体字オブジェクトへ変換する
  toItaiji (text, filteredFavoriteVariantCharacters = []) {
    if (!text) {
      return [];
    }

    return text.split("").map(character => {
      const obj = {
        variantCharacterId: null,
        character,
        imageUrl: null,
        points: [],
      };

      // 登録されたお気に入り異体字に該当する文字があるか探す
      const favoriteVariantCharacter = filteredFavoriteVariantCharacters.find(item => {
        return item.character === character;
      });

      if (favoriteVariantCharacter) {
        obj.variantCharacterId = favoriteVariantCharacter.variantCharacter.id;
        obj.imageUrl = favoriteVariantCharacter.variantCharacter.imageUrlForTablet;
      }

      return obj;
    });
  },

  // 異体字オブジェクトからテキストを抽出する
  getText (itaijiObject) {
    if (!itaijiObject) {
      return "";
    }
    if (itaijiObject._data) {
      return itaijiObject._data.reduce((cur, next) => cur + next.character, "");
    }
    return itaijiObject.reduce((cur, next) => cur + next.character, "");
  },

  // 異体字オブジェクトからテキストの長さを取得する
  getTextLength (itaijiObject) {
    const text = itaijiFM.getText(itaijiObject);
    return text.length;
  },
};

export const plugins = {
  install (Vue) {
    Vue.prototype.$itaijiFM = itaijiFM;
  },
};
